import { render } from "./MainNavNotifications.vue?vue&type=template&id=1ddea078"
import script from "./MainNavNotifications.vue?vue&type=script&lang=js"
export * from "./MainNavNotifications.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__